export default __webpack_public_path__ + "static/media/Jalsa1.1009e6f8.mp3";